/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressView } from './AddressView';
import type { MoneyView } from './MoneyView';
import type { ShopifyOrderItemView } from './ShopifyOrderItemView';
export type ShopifyOrderView = {
    /**
     * Shop ID (UUID)
     */
    shopId: string;
    /**
     * Shop type (e.g. jtl_shop_5, shopify_shop)
     */
    shopType: ShopifyOrderView.shopType;
    /**
     * Shopify order GID numeric part
     */
    id: number;
    /**
     * Order name/number (e.g. #1001)
     */
    orderNumber: string;
    orderDate?: string | null;
    isShipped?: boolean;
    totalPriceNet?: MoneyView | null;
    totalPriceGross?: MoneyView | null;
    /**
     * Order status (combined financial + fulfillment)
     */
    status?: string | null;
    /**
     * First product image URL
     */
    thumbnail?: string | null;
    items?: Array<ShopifyOrderItemView> | null;
    /**
     * Payment method name (from paymentGatewayNames)
     */
    billingMethodName?: string | null;
    /**
     * Shipping method name
     */
    shippingMethodName?: string | null;
    /**
     * Customer full name
     */
    customerName?: string | null;
    /**
     * Customer email
     */
    customerEmail?: string | null;
    /**
     * Billing address
     */
    billingAddress?: AddressView | null;
    /**
     * Shipping address
     */
    shippingAddress?: AddressView | null;
    /**
     * Order note/comment
     */
    comment?: string | null;
    /**
     * Tracking number/info
     */
    tracking?: string | null;
    /**
     * Financial status (PAID, PENDING, REFUNDED, etc.)
     */
    financialStatus?: string | null;
    /**
     * Fulfillment status (FULFILLED, UNFULFILLED, PARTIALLY_FULFILLED)
     */
    fulfillmentStatus?: string | null;
    /**
     * Shipping cost
     */
    shippingPrice?: MoneyView | null;
    /**
     * Customer phone
     */
    customerPhone?: string | null;
};
export namespace ShopifyOrderView {
    /**
     * Shop type (e.g. jtl_shop_5, shopify_shop)
     */
    export enum shopType {
        JTL_SHOP_5 = 'jtl_shop_5',
        JTL_WAWI_1_5 = 'jtl_wawi_1_5',
        JTL_WAWI_1_6 = 'jtl_wawi_1_6',
        EBAY_SHOP = 'ebay_shop',
        AMAZON_SHOP = 'amazon_shop',
        SHOPIFY_SHOP = 'shopify_shop',
    }
}

